import request from './request'

/**
 * 发送分享数据到服务端用于调试
 * @param {Object} shareData 分享数据
 * @returns {Promise}
 */
export function logShareData(shareData) {
  return request({
    url: '/api/share/mgs',
    method: 'post',
    data: shareData
  })
}

/**
 * 获取分享配置
 * @param {Object} params 参数
 * @returns {Promise}
 */
export function getShareConfig(params) {
  return request({
    url: '/api/share/config',
    method: 'get',
    params
  })
}

export default {
  logShareData,
  getShareConfig
}